import User from 'records/User';
import React, {useEffect, useState} from 'react';
import AccountSource from 'sources/AccountSource';
import SlackForm from 'components/pure/admin/profile/components/SlackForm';

export default function SlackFormContainer(props: {user: User}) {
  const [hasSlack, setHasSlack] = useState(false);

  useEffect(() => {
    AccountSource.hasSlack().then(setHasSlack);
  }, []);

  if (!hasSlack) return null;

  const {user} = props;

  return <SlackForm user={user} />;
}
